//  * Sophia Karamichali
//  * 05.07.2023

//  * Description:
//  *    Analytics component to allow for charts and collective responses to be displayed through
//  *    the survey component

import React, { useState, useEffect, useMemo, useRef } from 'react';
import { SafeAreaView, StyleSheet, useWindowDimensions } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { Chart } from "react-google-charts";
import { Select, MenuItem } from '@mui/material/';

const CustomAnalytics = ({ chartOptions, questionOptionResponseList, chartData, questionOption, question_option_id, question_option_name, questionName, input_type_name, questionId }) => {

    const { colors } = useTheme()
    const { width, height } = useWindowDimensions();
    const styles = makeStyles(colors, height, width);
    const respValuesText = useRef([]);
    const valuesWithIdFive = useRef([]);
    const [chartValue, setChartValue] = useState('PieChart');
    const questionOptionResponseListNew = useRef([]);
    const respValueSlider = useRef([]);
    const respValueRating = useRef([]);
    const valueWithId = useRef([]);
    var respValue;
    const withCountRef = useRef({});
    const [trueFalseAnalytics, setTrueFalseAnalytics] = useState([
        ["", "Count", { role: "style" }],
        ["False", 0, "red"],
        ["True", 0, "green"],
    ])
    const [agreeAnalytics, setAgreeAnalytics] = useState([
        ["", "Count", { role: "style" }],
        ["Strongly Agree", 0, "#00FF00"],
        ["Agree", 0, "#7FFF00"],
        ["Neutral", 0, "#FFFF00"],
        ["Disagree", 0, "#FFA500"],
        ["Strongly Disagree", 0, "#FF0000"],
    ])
    const listOfUnique = useRef([]);
    const listOfUniqueRating = useRef([]);
    const listOfUniqueTF = useRef([]);;
    const ratingCountListFive = useRef([0, 0, 0, 0, 0]);
    const ratingCountListTen = useRef([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    const [list, setList] = useState([]);


    //#region Chart Definitions 

    const handleChartViewChange = (e) => {
        const { value } = e.target;
        setChartValue(value)
    }

    const optionsOptionsChart = {
        hAxis: {
            title: 'Options',
            format: '0',
            textStyle: { color: colors.text_primary },
            titleTextStyle: { color: colors.text_primary }
        },
        vAxis: {
            title: 'Frequency',
            format: '0',
            textStyle: { color: colors.text_primary },
            titleTextStyle: { color: colors.text_primary }
        },
        legend: { textStyle: { color: colors.text_primary } },
        color: colors.text_primary,
        backgroundColor: 'trasparent',
        opacity: 0,
        'chartArea': {
            'backgroundColor': {
                'fill': 'trasparent',
                'opacity': 0
            },
        }
    }

    const optionsRatingChart = {
        hAxis: {
            title: 'Rating Value',
            format: '0',
            textStyle: { color: colors.text_primary },
            titleTextStyle: { color: colors.text_primary }
        },
        vAxis: {
            title: 'Frequency',
            format: '0',
            textStyle: { color: colors.text_primary },
            titleTextStyle: { color: colors.text_primary }
        },
        legend: { textStyle: { color: colors.text_primary } },
        backgroundColor: 'trasparent',
        opacity: 0,
        'chartArea': {
            'backgroundColor': {
                'fill': 'trasparent',
                'opacity': 0
            },
        }
    }

    const optionsTrueFalseChart = {
        hAxis: {
            title: 'True/False',
            format: '0',
            textStyle: { color: colors.text_primary },
            titleTextStyle: { color: colors.text_primary },
        },
        vAxis: {
            title: 'Frequency',
            format: '0',
            textStyle: { color: colors.text_primary },
            titleTextStyle: { color: colors.text_primary }
        },
        legend: { textStyle: { color: colors.text_primary } },
        backgroundColor: 'trasparent',
        opacity: 0,
        'chartArea': {
            'backgroundColor': {
                'fill': 'trasparent',
                'opacity': 0
            },
        }
    }
    const optionsAgreeDisagreeChart = {
        hAxis: {
            title: 'Agree/Disagree',
            format: '0',
            textStyle: { color: colors.text_primary },
            titleTextStyle: { color: colors.text_primary },
        },
        vAxis: {
            title: 'Frequency',
            format: '0',
            textStyle: { color: colors.text_primary },
            titleTextStyle: { color: colors.text_primary }
        },
        legend: { textStyle: { color: colors.text_primary } },
        backgroundColor: 'trasparent',
        opacity: 0,
        'chartArea': {
            'backgroundColor': {
                'fill': 'trasparent',
                'opacity': 0
            },
        }
    }

    const optionsSliderChart = {
        hAxis: {
            title: 'Slider Percentage',
            format: '0',
            textStyle: { color: colors.text_primary },
            titleTextStyle: { color: colors.text_primary },
        },
        vAxis: {
            title: 'Frequency',
            format: '0',
            textStyle: { color: colors.text_primary },
            titleTextStyle: { color: colors.text_primary }
        },
        legend: { textStyle: { color: colors.text_primary } },
        backgroundColor: 'trasparent',
        opacity: 0,
        'chartArea': {
            'backgroundColor': {
                'fill': 'trasparent',
                'opacity': 0
            },
        }
    }
    //#endregion

    useEffect(() => {
        questionOption.map((option) => {
            setList(list => [...list, option.id])
        })

        questionOptionResponseList.current.map((qorItr) => {
            if (qorItr.question_option_id === question_option_id) {
                questionOptionResponseListNew.current.push(qorItr)
            }
        })
    }, []);

    //#region Data creation
    var getData = (qNmae) => {
        var d = chartData.filter((x) => x.question_name === qNmae.title)
        let dTemp = [["Question", "Count"]]
        d.map((dItr) => {
            console.log(dItr)
            dTemp.push([dItr.question_option_name, dItr.count])
        })
        return dTemp;
    }

    var getTextData = (qorItr, index) => {
        if (qorItr.question_option_id === question_option_id) {
            if (!listOfUnique.current.includes(qorItr.id)) {
                listOfUnique.current.push(qorItr.id)
                if (input_type_name === "Text" && qorItr.answer_text != '') {
                    respValue = qorItr.answer_text
                    respValuesText.current.push(qorItr.answer_text)
                    return (<div style={{ marginLeft: '20px', marginRight: '20px' }}>{qorItr.answer_text}<hr /></div>)
                }

            }
        }

        if (list.includes(qorItr.question_option_id)) {
            listOfUnique.current.push(qorItr.id)
            //check type and whether it is selected
            if (input_type_name === "Slider") {
                respValue = qorItr.answer_numeric
                //* Prevent duplicates from being included in
                if (!valueWithId.current.includes(qorItr)) {
                    if (respValueSlider.current.includes(qorItr.answer_numeric)) {
                        withCountRef.current[qorItr.answer_numeric]++;
                        console.log(withCountRef.current)
                    }
                    withCountRef.current[qorItr.answer_numeric] = 1;
                    respValueSlider.current.push(qorItr.answer_numeric)
                    valueWithId.current.push(qorItr)
                }
            }
        }

        if (list.includes(qorItr.question_option_id)) {
            let tempAgreeAnalytics = agreeAnalytics;
            listOfUnique.current.push(qorItr.id)
            //check type and whether it is selected
            if (input_type_name === "Rating Options" && qorItr.answer_yn != 0) {
                respValue = qorItr.answer_yn
                //Prevent duplicates from being included in
                if (!valueWithId.current.includes(qorItr)) {
                    respValueRating.current.push(qorItr.answer_yn)
                    valueWithId.current.push(qorItr)
                    console.log(qorItr)
                    questionOption.map(option => {
                        if (option.id === qorItr.question_option_id) {
                            console.log(option)
                            option.option_order % 6 === 1 && qorItr.answer_yn === 1 &&
                                tempAgreeAnalytics[option.option_order % 6][1]++;
                            option.option_order % 6 === 2 && qorItr.answer_yn === 1 &&
                                tempAgreeAnalytics[option.option_order % 6][1]++;
                            option.option_order % 6 === 3 && qorItr.answer_yn === 1 &&
                                tempAgreeAnalytics[option.option_order % 6][1]++;
                            option.option_order % 6 === 4 && qorItr.answer_yn === 1 &&
                                tempAgreeAnalytics[option.option_order % 6][1]++;
                            option.option_order % 6 === 5 && qorItr.answer_yn === 1 &&
                                tempAgreeAnalytics[option.option_order % 6][1]++;
                        }
                    })

                    console.log(tempAgreeAnalytics)
                    setAgreeAnalytics(tempAgreeAnalytics);

                    let r = (index % 6 === 0) && qorItr.answer_yn ?
                        <>{question_option_name[Math.floor(index / 6)]}</> :
                        (index % 6 === 1) ? <div style={{ color: "black" }}>Strongly Agree, {index}</div> :
                            (index % 6 === 2) ? <div style={{ color: "black" }}>Agree, {index}</div> :
                                (index % 6 === 3) ? <div style={{ color: "black" }}>Neutral, {index}</div> :
                                    (index % 6 === 4) ? <div style={{ color: "black" }}>Disagree, {index}</div> :
                                        (index % 6 === 5) ? <div style={{ color: "black" }}>Strongly Disagree, {index}</div> : <></>
                    return (<div style={{ marginLeft: '20px', marginRight: '20px' }}>{r}<hr /></div>)
                }
            }
        }

        if (list.includes(qorItr.question_option_id) && input_type_name === "True/False Options") {
            let tempTrueFalseAnalytics = trueFalseAnalytics
            if (!listOfUniqueTF.current.includes(qorItr.id)) {
                listOfUniqueTF.current.push(qorItr.id)
                respValue = qorItr.answer_yn
                var name

                questionOption.map(option => {
                    if (option.id === qorItr.question_option_id) {
                        option.option_order === 0 && qorItr.answer_yn === 1 &&
                            tempTrueFalseAnalytics[1][1]++
                        option.option_order === 1 && qorItr.answer_yn === 1 &&
                            tempTrueFalseAnalytics[2][1]++
                    }
                })
                setTrueFalseAnalytics(tempTrueFalseAnalytics)
                return;
            }
        }
    }

    var getSliderDataCount = (qorItr) => {
        let dTemp1 = ["Question", "Count"]
        let a = (Object.entries(qorItr.current).map(([key, value]) => [key + '%', value]))
        let dTemp = [dTemp1, ...a]
        return (dTemp)

    }

    var getTrueFalseData = (qorItr) => {
        console.log(qorItr)
        let dTemp1 = ["Question", "Count"]
        let a = (Object.entries(qorItr.current).map(([key, value]) => [key + '%', value]))
        let dTemp = [dTemp1, ...a]
        return (dTemp)
    }

    var getRatingData = (qorItr) => {
        if (!listOfUniqueRating.current.includes(qorItr.id)) {
            listOfUniqueRating.current.push(qorItr.id)
            if (qorItr.question_option_id === question_option_id || question_option_id === undefined) {
                if (input_type_name === 'Rating(10)') {
                    if (!valuesWithIdFive.current.includes(qorItr)) {
                        valuesWithIdFive.current.push(qorItr)
                        respValue = qorItr.answer_numeric
                        ratingCountListTen.current[respValue - 1]++;
                    }
                }
                if (input_type_name === 'Rating(5)') {
                    if (!valuesWithIdFive.current.includes(qorItr)) {
                        valuesWithIdFive.current.push(qorItr)
                        respValue = qorItr.answer_numeric
                        ratingCountListFive.current[respValue - 1]++;
                    }
                }
            }

        }
    }

    var getRatingDataCount = (qorItr) => {
        let dTemp = [["Question", "Count"]]
        qorItr.map((id, count) => {
            dTemp.push([(count + 1).toString(), id])
            return (<div>{id}{count}</div>)

        })
        return dTemp;
    }
    //#endregion
    return (
        <SafeAreaView
            style={styles.main}>

            <div style={{ display: "none" }}>
                {optionsRatingChart.backgroundColor = "transparent"} {optionsSliderChart.backgroundColor = "transparent"}
            </div>
            {/* * Display Text Data */}
            {questionOptionResponseList.current.map((qorItr, index) =>
                <SafeAreaView
                    key={index}>
                    {getTextData(qorItr, index)}
                </SafeAreaView>)}

            {/* * Display Reting(5) Data in a chart */}
            {
                questionOptionResponseList.current.map((qorItr, index) =>
                    <SafeAreaView
                        key={index}>
                        {getRatingData(qorItr) && qorItr.question_option_id === question_option_id ?
                            <SafeAreaView>
                                {getRatingData(qorItr)}
                            </SafeAreaView>
                            : <></>}
                    </SafeAreaView>
                )
            }
            {input_type_name === "Rating(10)" ?
                <Chart
                    chartType="ColumnChart"
                    data={getRatingDataCount(ratingCountListTen.current)}
                    options={optionsRatingChart}
                    width={"1000px"}
                    height={"400px"}
                />
                : <>{input_type_name === "Rating(5)" &&
                    <>
                        <Chart
                            chartType="ColumnChart"
                            data={getRatingDataCount(ratingCountListFive.current)}
                            options={optionsRatingChart}
                            width={"1000px"}
                            height={"400px"}
                        /></>
                }</>
            }

            {input_type_name === "Slider" &&
                <>
                    <Chart
                        chartType="ColumnChart"
                        data={getSliderDataCount(withCountRef)}
                        options={optionsSliderChart}
                        width={"1000px"}
                        height={"400px"}
                    /> </>
            }

            {input_type_name === "True/False Options" &&
                <>
                    <Chart
                        chartType="ColumnChart"
                        data={trueFalseAnalytics}
                        options={optionsTrueFalseChart}
                        width={"1000px"}
                        height={"400px"}
                    /> </>
            }
            {input_type_name === "Rating Options" &&
                <>
                    <Chart
                        chartType="ColumnChart"
                        data={agreeAnalytics}
                        options={optionsAgreeDisagreeChart}
                        width={"1000px"}
                        height={"400px"}
                    /> </>
            }

            {/* * Display Options Charts */}
            {chartOptions.map((cItr) =>
                questionName === cItr.title && input_type_name === "Options" ?
                    <><div style={{ display: "none" }}> {optionsOptionsChart.backgroundColor = "transparent"}</div>
                        <Select className="chartMenu"
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            defaultValue=""
                            value={chartValue}
                            label="Select Chart View"
                            onChange={(e) => handleChartViewChange(e)}

                        >
                            <MenuItem value={"PieChart"}>Pie Chart</MenuItem>
                            <MenuItem value={"BarChart"}>Bar Chart</MenuItem>
                        </Select>
                        {chartValue === "PieChart" &&
                            <Chart className="chartpie"
                                chartType="PieChart"
                                title={cItr}
                                data={getData(cItr)}
                                options={optionsOptionsChart}
                                width={"1000px"}
                                height={"400px"}
                                color='transparent'
                            />}
                        {chartValue === "BarChart" &&
                            <Chart
                                chartType="ColumnChart"
                                data={getData(cItr)}
                                options={optionsOptionsChart}
                                width={"1000px"}
                                height={"400px"}
                                title={cItr}
                            />}

                    </>
                    : <></>
            )}
        </SafeAreaView>
    );
};

const makeStyles = (colors, height, width) => StyleSheet.create({
    main: {
        flex:1,
    },
})

export default CustomAnalytics; 